module.exports = __webpack_public_path__ + "static/AvenirLTStd-LightOblique-ec050e0043b1e063d5502d3a2d0a191a.woff";